module.exports = __webpack_public_path__ + "img/bgr-tickling-stars.d2990fe6.svg";